/**
 * Console.logをラップするクラス
 * URLで開発環境かどうかを判定します。
 * */
export module Logger {

	var isDebug = false;
	const devUrl = ["localhost", "127.0.0.1", "dev-pcs-prt-ja","stg-pcs-prt-ja"];

	export function init() {

		const current = window.location.href;
		let rt = devUrl.filter(url => {
			return current.indexOf(url) > 0;
		});
		if (rt.length > 0) {
			isDebug = true;
		}

	}

	export function info(message?: any, ...optionalParams: any[]) {
		if (isDebug && typeof console.info != "undefined") {
			if (optionalParams.length > 0) {
				console.info(message, optionalParams);
			} else {
				console.info(message);
			}
		}
	}

	export function log(message?: any, ...optionalParams: any[]) {
		if (isDebug && typeof console.log != "undefined") {
			if (optionalParams.length > 0) {
				console.log(message, optionalParams);
			} else {
				console.log(message);
			}
		}
	}

	export function debug(message?: any, ...optionalParams: any[]) {
		if (isDebug && typeof console.debug != "undefined") {
			if (optionalParams.length > 0) {
				console.debug(message, optionalParams);
			} else {
				console.debug(message);
			}
		}
	}

	export function warn(message?: any, ...optionalParams: any[]) {
		if (isDebug && typeof console.warn != "undefined") {
			if (optionalParams.length > 0) {
				console.warn(message, optionalParams);
			} else {
				console.warn(message);
			}
		}
	}

	export function error(message?: any, ...optionalParams: any[]) {
		if (isDebug && typeof console.error != "undefined") {
			if (optionalParams.length > 0) {
				console.error(message, optionalParams);
			} else {
				console.error(message);
			}
		}
	}

	export function trace(message?: any, ...optionalParams: any[]) {
		if (isDebug && typeof console.trace != "undefined") {
			if (optionalParams.length > 0) {
				console.trace(message, optionalParams);
			} else {
				console.trace();
			}
		}
	}
}